"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ToastFooter: function() {
        return _index.ToastFooter;
    },
    renderToastFooter_unstable: function() {
        return _index.renderToastFooter_unstable;
    },
    toastFooterClassNames: function() {
        return _index.toastFooterClassNames;
    },
    useToastFooterStyles_unstable: function() {
        return _index.useToastFooterStyles_unstable;
    },
    useToastFooter_unstable: function() {
        return _index.useToastFooter_unstable;
    }
});
const _index = require("./components/ToastFooter/index");
